import script from "./app-group-import-form.vue?vue&type=script&setup=true&lang=js"
export * from "./app-group-import-form.vue?vue&type=script&setup=true&lang=js"

import "./app-group-import-form.vue?vue&type=style&index=0&id=1244a786&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1244a786"]])

export default __exports__